<template lang="pug">
  .b2b-search-bar(:class="{'b2b-search-bar--open': isOpen}")
    .b2b-search-bar__header
      div.b2b-search-bar__header-left()
        slot(name='body')
      div.b2b-search-bar__header-right(
        v-if='hasSlotHeader',
        @click='showModal')
        slot(name='header')
    ods-collapse-transition
      .b2b-search-bar__content(v-show='isOpen')
        .b2b-search-bar__content-inner
          slot
</template>

<script>
export default {
  name: 'b2b-search-bar',
  computed: {
    isOpen () {
      return this.$store.getters.searchBarToggle
    },
    hasSlotHeader () {
      return this.$slots.header
    }
  },
  methods: {
    toggleSearchBar (status) {
      this.$store.dispatch('searchBarToggleStatus', !status)
    },
    showModal () {
      this.$store.dispatch('invoiceModalState', true)
    }
  }
}
</script>

<style lang="scss" scoped>
.b2b-search-bar {
  background-color: var(--color-bg-primary);
  padding-left: rem(24);
  line-height: 4.5rem;
  &__header {
    display: flex;
    justify-content: space-between;
    &-left {
      input {
        max-width: rem(120);
      }
      transition: all .3s;
      //cursor: pointer;
    }
    &-right {
      text-align: right;
    }
  }
}
</style>
